module.exports = "https://cdn-shared.mathletics.com/teacher-modules/school-usage-reports/95/assets/images/f0c0c4f3f902644844186ea5c79378e1.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/badges/Diamond/Diamond5.svg
// module id = qC0W
// module chunks = 1